module.exports = __webpack_public_path__ + "img/132.3377b24d.jpg";